export const useSecurityQuestionsStore = defineStore(
  "securityQuestions",
  () => {
    // State
    const showSetupModal = ref(false);
    const intendedDestination = ref("");
    const isSetupRequired = ref(false);

    // Actions
    function setRequiredSetup(required: boolean, destination?: string) {
      isSetupRequired.value = required;
      showSetupModal.value = required;
      if (destination) {
        intendedDestination.value = destination;
      }
    }

    function completeSetup() {
      showSetupModal.value = false;
      isSetupRequired.value = false;

      // Navigate to intended destination if available
      if (intendedDestination.value) {
        const destination = intendedDestination.value;
        intendedDestination.value = "";
        navigateTo(destination);
      }
    }

    function skipSetup() {
      showSetupModal.value = false;
      isSetupRequired.value = false;
      intendedDestination.value = "";
    }

    function hideModal() {
      showSetupModal.value = false;
    }

    // Getters
    const shouldShowSetup = computed(() => showSetupModal.value);

    return {
      // State
      showSetupModal: readonly(showSetupModal),
      intendedDestination: readonly(intendedDestination),
      isSetupRequired: readonly(isSetupRequired),

      // Getters
      shouldShowSetup,

      // Actions
      setRequiredSetup,
      completeSetup,
      skipSetup,
      hideModal,
    };
  },
);
